import { createAsyncThunk } from "@reduxjs/toolkit";
import luckyDrawV2Api from "app/api/luckyDrawV2";

const LUCKY_DRAW_V2 = "luckyDrawV2";

// Fetch Traditional Raffle list
export const fetchTraditionalRaffleList = createAsyncThunk(
  `${LUCKY_DRAW_V2}/fetchTraditionalRaffleList`,
  async (payload, thunkApi) => {
    try {
      const response = await luckyDrawV2Api.getTraditionalRaffleList(payload);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

// Fetch Instant Win list
export const fetchInstantWinList = createAsyncThunk(
  `${LUCKY_DRAW_V2}/fetchInstantWinList`,
  async (payload, thunkApi) => {
    try {
      const response = await luckyDrawV2Api.getInstantWinList(payload);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
